import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myLeaveCurrentDateState = atom({
  key: "currentDate",
  default: new Date(),
  effects_UNSTABLE: [ocPersistAtom],
});
